import { useQuery } from '@tanstack/react-query'

import { pollsQueries } from '@/http/api/polls'

type UsePollDetailsParams = {
  pollId: string
  enabled?: boolean
}

export function usePollDetails({ pollId, enabled }: UsePollDetailsParams) {
  return useQuery({
    ...pollsQueries.detail(pollId),
    enabled,
  })
}
